module.exports = __webpack_public_path__ + "img/burger.9a8fe51d.png";